"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilters = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../hooks");
const utility_1 = require("../utility");
const useFilters = () => {
  const {
    options,
    config
  } = (0, hooks_1.useReactifySearchContext)();
  const filterStack = react_1.default.useMemo(() => {
    if (options.mode === "instant-search") {
      return undefined;
    }
    // select filters by type
    const matchingFilterss = config.filters.filter(filter => filter.type === options.mode);
    // select filter stack by handle if provided
    if (options.filtersHandle) {
      const matchingFilters = matchingFilterss.find(filterStack => options.filtersHandle === filterStack.handle);
      if (matchingFilters) {
        return matchingFilters;
      }
    }
    // select filter stack by collection if provided
    if (options.mode === "collection" && options.collectionHandle) {
      const matchingFilters = matchingFilterss.find(filterStack => {
        var _a;
        return (_a = filterStack.collections) === null || _a === void 0 ? void 0 : _a.includes(options.collectionHandle);
      });
      if (matchingFilters) {
        return matchingFilters;
      }
    }
    // select filter with "default" handle
    let matchingFilters = matchingFilterss.find(filterStack => filterStack.handle === "default");
    if (matchingFilters) {
      return matchingFilters;
    }
    // select any filter with "default" handle
    matchingFilters = config.filters.find(filterStack => filterStack.handle === "default");
    if (matchingFilters) {
      return matchingFilters;
    }
    // select any available filter as a last resort
    matchingFilters = config.filters[0];
    return matchingFilters;
  }, [config, options.mode === "collection" ? options.collectionHandle : undefined]);
  const filters = react_1.default.useMemo(() => {
    const sortedFilters = filterStack === null || filterStack === void 0 ? void 0 : filterStack.options.sort((a, b) => a.position > b.position ? 1 : -1);
    return sortedFilters;
  }, [filterStack]);
  utility_1.debug.hook("useFilters", "filterStack", filterStack);
  utility_1.debug.hook("useFilters", "filters", filters);
  return {
    filterStack: filterStack,
    filters: filters
  };
};
exports.useFilters = useFilters;